<script>
  import { createEventDispatcher } from 'svelte';
  import {
    Button,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Spinner
  } from "sveltestrap";

  export let title = '';
  export let message = '';
  export let confirmLabel = 'Yes';
  export let cancelLabel = 'No';

  export let open = false;
  export let toggle = () => (open = !open);
  export let action = () => {};

  let busy = false;
  let dispatch = createEventDispatcher();

  function confirm() {
    busy = true;
    const execute = new Promise((resolve) => {
      action();
      resolve();
    })
      .then(_ => toggle())
      .then(_ => dispatch('completed'))
      .finally(_ => busy = false);
  }

  function cancel() {
    toggle();
  }
</script>

<style>
</style>

<Modal isOpen={open} {toggle} transition="fade">
  <ModalHeader {toggle}>{title}</ModalHeader>
  <ModalBody>{message}</ModalBody>
  <ModalFooter>
    {#if busy}
      <Button color="primary" style="cursor: not-allowed; opacity: 0.5" disabled>
        <Spinner size="sm" />
      </Button>
    {:else}
      <Button color="primary" on:click={confirm}>{confirmLabel}</Button>
    {/if}
    <Button color="secondary" on:click={cancel}>{cancelLabel}</Button>
  </ModalFooter>
</Modal>
